@switch (asset.value.state) {
  @case ('pending') {
    <div class="flex items-center space-x-2">
      <p-message icon="pi pi-info-circle" severity="warn" variant="simple">
        No audio generated
      </p-message>
      <p-button
        text
        rounded
        icon="pi pi-sparkles"
        label="Generate Audio"
        appThrottleClick
        [throttleTime]="500"
        (throttleClick)="onGenerateClick()" />
    </div>
  }
  @case ('generating') {
    <p-message icon="pi pi-spin pi-spinner" severity="info" variant="simple">
      Audio is being generated...
    </p-message>
  }
  @case ('error') {
    <app-asset-error [error]="asset.value.error" />
  }
  @case ('ready') {
    <app-audio-asset-resource [resource]="asset.value.resource" />
  }
  @default {}
}
